import React from "react"
import Badge from "../atoms/Badge.atom"
import Tooltip from "../atoms/Tooltip.atom"
import { generateRandomNumber } from "../../utils/numbers.utils"

const ReportBadgeWithTooltip = ({
  value,
  tooltipValue = "",
  // if there's no position by default, then it's dynamic so it doesn't overflow the viewport
  position,
  iconClassName = null,
  iconProps,
  iconSvg,
  className,
  type,
  legend,
  badgeProps,
  tooltipProps,
  legendProps,
  ...rest
}) => {
  const id = generateRandomNumber()
  const renderIcon = () => {
    if (iconClassName) {
      return (
        <i
          className={`${iconClassName} flex align-items-center justify-content-center`}
          {...iconProps}
        />
      )
    } else if (iconSvg) {
      return iconSvg
    }
    return value || null
  }
  return (
    <span
      className={`${legend !== null || legend !== undefined ? "flex align-items-center min-w-4rem w-fit justify-content-between" : null}`}
    >
      <Tooltip
        target={`.report-badge-id-${id}`}
        className={`report-badge-tooltip report-badge-tooltip__${type}`}
        position={position}
        {...tooltipProps}
      >
        {tooltipValue}
      </Tooltip>
      <Badge
        className={`report-badge report-badge__${type} report-badge-id-${id} ${className} min-w-0 flex align-items-center justify-content-center`}
        value={renderIcon()}
        {...badgeProps}
      />
      <span className="ml-1" {...legendProps}>
        {legend}
      </span>
    </span>
  )
}

export default ReportBadgeWithTooltip
